import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { UserResourcesService } from "src/app/services/user-resources/user-resources.service";
import { loadUserResources, loadUserResourcesFailed, loadUserResourcesSuccess } from "../actions/user-resources.actions";

@Injectable()
export class UserResourcesEffects {
	private actions$ = inject(Actions);
	private userResourcesService = inject(UserResourcesService);


	// Load the portal product catalog from backend blob storage
	loadUserResource$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserResources),
		mergeMap((action) =>
			this.userResourcesService.loadUserResourcesByType(action.application, action.resourceType, action.authenticationKey, action.tenantId, action.skipToken, action.expandProperties).pipe(
				map(resp => loadUserResourcesSuccess({ m365UserId: action.m365UserId, resourceType: action.resourceType, userResources: resp.data, loadedFrom: "provisioning", expandedProperties: action.expandProperties })),
				catchError(async (error) => loadUserResourcesFailed({ m365UserId: action.m365UserId, resourceType: action.resourceType, error: error })),
			)
		)));

}
